import { formatPhoneNumber } from 'react-phone-number-input';

/**
 * Normalise a stored US phone to E.164, mirroring the gateway's
 * `services/phone.js` `normalizePhone`: strip non-digits, reject fewer than
 * ten digits, drop a leading country `1`, keep the last ten.
 */
const toE164 = (raw: string): string | null => {
    const digits = raw.replace(/\D/g, '');
    if (digits.length < 10) return null;
    const ten = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits.slice(-10);
    return `+1${ten}`;
};

/**
 * The phone number to SHOW for a stored `patient.phone`.
 *
 * `formatPhoneNumber` from react-phone-number-input only accepts E.164 and
 * returns '' for anything else, while `patient.phone` holds whatever was
 * written before the gateway normalised on write — seeded and older rows are
 * plain digits. So normalise first (the label then names the number Twilio
 * will actually dial, since `send-sms` normalises the same way server-side).
 *
 * Returns '' only for an absent phone, which is the caller's
 * "no phone on file" case.
 */
export const displayPhone = (raw: string | null | undefined): string => {
    if (!raw) return '';
    const e164 = toE164(raw);
    const formatted = e164 ? formatPhoneNumber(e164) : '';
    // Fewer than ten digits (or digits libphonenumber will not take as a US
    // number) cannot be formatted, but something IS on file — show it verbatim
    // rather than a blank destination, so staff can see the row is malformed.
    // Such a send is rejected by the gateway, which is where it belongs.
    return formatted || raw;
};
